<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row" v-if="authUser.permissions.dashboard_view === false">
      <div class="col-md-12">
        <h5 class="text-center"><b>Welcome, {{ authUser.name }}</b></h5>
      </div>
    </div>
    <div class="page-title-box noprint" v-if="authUser.permissions.dashboard_view === true">
      <div class="float-right">
        <div class="form-inline ml-auto">
          <select v-model="company_no" class="form-control mr-2">
            <option value="">-- All --</option>
            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
          </select>
          <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
          <button type="button" class="btn btn-sm btn-primary" @click="addSearch">
            <i class="fa fa-search" aria-hidden="true"></i>
          </button>
          <a href="javascript:window.print()" class="btn btn-sm btn-warning">Print</a>
        </div>
      </div>
      <h4 class="page-title">Dashboard</h4>
    </div>
    <div class="row" v-if="authUser.permissions.dashboard_view === true">
      <div class="col-md-4">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-success">Total Omzet</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span>{{ totalSales | currency }}</span>
            </h3>
            <p class="mb-0 text-muted text-truncate">
              Last Total Sales
              <span class="text-success">
                <i class="mdi mdi-trending-up"></i>
                {{ totalSalesBefore | currency }}
              </span>

            </p>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-4">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-warning">Total Retur</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span>{{ totalReturn | currency}}</span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
      </div>
      <div class="col-md-4">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-primary">Total Sales</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span>{{ totalSales - totalReturn | currency}}</span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
      </div>
      <!--end col-->
    </div>
    <div class="row" v-if="authUser.permissions.dashboard_view === true">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <v-chart class="chart" :option="option2" />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <v-chart class="chart" :option="option3" />
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="authUser.permissions.dashboard_view === true">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h5>Product Rank</h5>
            <div class="table-responsive">
              <table class="table table-sm mb-0 table-hover table-striped">
                <thead>
                  <th>Rank</th>
                  <th>Product</th>
                  <th class="text-right">Total Sales</th>
                </thead>
                <tbody>
                  <tr v-for="r in tableRankProduct" :key="r.rank">
                    <td>{{ r.rank }}</td>
                    <td><b>[{{ r.product_no }}]</b> {{ r.product }}</td>
                    <td class="text-right">{{ r.total_sales | currency }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h5>Salesman Rank</h5>
            <div class="table-responsive">
              <table class="table table-sm mb-0 table-hover table-striped">
                <thead>
                  <th>Rank</th>
                  <th>Product</th>
                  <th class="text-right">Total Sales</th>
                </thead>
                <tbody>
                  <tr v-for="r in tableRankSalesman" :key="r.rank">
                    <td>{{ r.rank }}</td>
                    <td><b>[{{ r.salesman_id }}]</b> {{ r.salesman }}</td>
                    <td class="text-right">{{ r.total_sales | currency }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row noprint" v-if="authUser.permissions.dashboard_manufacture_view === true">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <h5>Manufacture:</h5>
              <table class="table-sm table-striped table">
                <thead>
                  <th>Status</th>
                  <th>Manufacture No.</th>
                  <th>Date</th>
                  <th>Product</th>
                  <th>Qty</th>
                  <th>Uom</th>
                  <th>Customer</th>
                </thead>
                <tbody>
                  <tr v-for="mo in manufactureOrder" :key="mo.id" @click="toManufacture(mo.m_id)">
                    <td>
                      <span v-if="mo.status !== 'finish'" class="badge badge-success">{{ mo.status }}</span>
                      <span v-else class="badge badge-primary">{{ mo.status }}</span>
                    </td>
                    <td><b style="cursor: pointer; color: #28A745;">{{ mo.manufacture_no }}</b></td>
                    <td>{{ mo.manufacture_date | dateFormat('DD/MM/YYYY') }}</td>
                    <td><b>[{{ mo.product_no}}]</b> {{ mo.product }}</td>
                    <td>{{ mo.qty | currency }}</td>
                    <td>{{ mo.uom_id }}</td>
                    <td>{{ mo.customer }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <h5>
                <span>Summary Order:</span>
                <span class="spinner-border spinner-border-sm pull-right" role="status" aria-hidden="true" v-if="dataOrderLoading"></span>
                <button class="btn btn-primary" @click="getSummaryOrder">Refresh</button>
              </h5>
              <table class="table-sm table-striped table">
                <thead>
                  <th>Product</th>
                  <th>Begin</th>
                  <th>Order/Manufacture</th>
                  <th>Sales Order</th>
                  <th>Remaining</th>
                </thead>
                <tbody>
                  <tr v-for="o in dataOrderMinus" :key="o.id">
                    <td><b>[{{ o.product_no}}]</b> {{ o.product_name }}</td>
                    <td>{{ o.costs.cost_qty }} {{ o.costs.uom_id }}</td>
                    <td>{{ o.purchasing_order_remaining }}</td>
                    <td>{{ o.sale_order_remaining }}</td>
                    <td>{{ o.saldo }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row noprint" v-if="authUser.permissions.dashboard_view === true">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h5>Approval & Lock:</h5>
            <div class="table-responsive">
              <table class="table table-sm table-striped">
                <thead>
                  <th>Type</th>
                  <th>Ref No</th>
                  <th>Date</th>
                  <th>User</th>
                  <th>Notes</th>
                </thead>
                <tbody>
                  <tr v-for="i in notifData" :key="i.id" @click="toApprove(i.id, i.type)">
                    <td>
                      <span v-if="i.type === 'lock'" class="badge badge-warning">{{ i.type }}</span>
                      <span v-else>{{ i.type }}</span>
                    </td>
                    <td>{{ i.ref_no}} -  {{ i.ref_no2 }}</td>
                    <td>{{ i.date | dateFormat('DD/MM/YYYY') }}</td>
                    <td><b>[{{ i.user_id}}]</b> {{ i.user }}</td>
                    <td>{{ i.notes }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import axios from 'axios'
// import { reportUrl, getHeader } from '@/config'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Axios from 'axios'
import { getHeader, productUrl, reportUrl, setRowUrl } from '../config'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart } from 'echarts/charts'
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent } from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
])

export default {
  name: 'Home',
  components: { DatePicker, Loading, VChart },
  provide: { [THEME_KEY]: 'light' },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      dataOrder: [],
      dataOrderLoading: false,
      manufactureOrder: [],
      tableRankProduct: [{
        rank: null,
        product_no: null,
        product: null,
        total_sales: '0'
      }],
      tableRankSalesman: [{
        rank: null,
        salesman_id: null,
        salesman: null,
        total_sales: '0'
      }],
      option2: {},
      option3: {},
      option: {},
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      company_no: '',
      loadingSales: false,
      startDate: [date1, date2],
      branch_no: 100,
      totalSales: '0',
      totalReturn: '0',
      totalSalesBefore: '0',
      totalService: '0',
      productTopTen: [{
        product_no: null,
        total: null,
        product: {
          product_name: null
        }
      }],
      notifData: []
    }
  },
  methods: {
    async print () {
      const option = {
        name: '_blank',
        specs: [
          'fullscreen=yes',
          'titlebar=yes',
          'scrollbars=yes'
        ],
        styles: [
          'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
          'https://unpkg.com/kidlat-css/css/kidlat.css'
        ],
        timeout: 1000,
        autoClose: true,
        windowTitle: 'Vue Html To Paper - Vue mixin for html elements printing.'
      }
      await this.$htmlToPaper('printScreen', option)
    },
    toManufacture (id) {
      const routeData = this.$router.resolve({ name: 'manufacture', query: { id: id } })
      window.open(routeData.href, '_blank')
      // this.$router.replace({ path: '/manufacture', query: { id: id } })
      // window.location.reload()
    },
    toApprove (id, type) {
      if (type === 'order') {
        this.$router.replace({ path: '/sale/order', query: { refno: id } })
        window.location.reload()
      }
    },
    async getNotification () {
      await Axios.get(reportUrl + '/notification', { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.notifData = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
        })
    },
    async getSalesmanRank () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      await Axios.post(reportUrl + '/salesman-top-ten', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.tableRankSalesman = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getProductRank () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      await Axios.post(reportUrl + '/product-top-ten', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.tableRankProduct = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getSaleSummary () {
      this.loadingSales = false
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      await Axios.post(reportUrl + '/sales-summary', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.totalSales = response.data.data[0].total_sales
          this.totalSalesBefore = response.data.data[0].total_sales_before
          this.totalReturn = response.data.data[0].total_return_sales
          this.loadingSales = true
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getSaleByMonthly () {
      const year = this.startDate[0].getFullYear()
      var obj = {
        year: year,
        company: this.company_no
      }
      console.log(obj)
      console.log(reportUrl + '/sales-by-monthly')
      await Axios.post(reportUrl + '/sales-by-monthly', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          var data = []
          var data2 = []
          var data3 = []
          var array = response.data.data
          for (let i = 0; i < array.length; i++) {
            data.push(array[i].total_sales)
            data2.push(array[i].total_return)
            data3.push(array[i].total)
          }
          console.log(response.data.label)
          console.log(data)
          this.option2 = {
            title: {
              text: 'Sales By Monthly',
              left: 'left'
            },
            legend: {},
            tooltip: {
              trigger: 'axis'
            },
            xAxis: {
              type: 'category',
              data: response.data.label
            },
            yAxis: {
              type: 'value'
            },
            series: [{
              data: data3,
              type: 'bar',
              name: 'Total',
              itemStyle: { color: '#4EA397' },
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              }
            }, {
              data: data,
              type: 'bar',
              name: 'Omzet',
              itemStyle: { color: '#22C3AA' },
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              }
            }, {
              data: data2,
              type: 'bar',
              name: 'Retur',
              itemStyle: { color: '#7BD9A5' },
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              }
            }]
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getSaleByDaily () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      console.log(obj)
      console.log(reportUrl + '/sales-by-daily')
      await Axios.post(reportUrl + '/sales-by-daily', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          var data = []
          var array = response.data.data
          for (let i = 0; i < array.length; i++) {
            data.push(array[i].amount)
          }
          console.log(response.data.label)
          console.log(data)
          this.option3 = {
            title: {
              text: 'Sales Daily Chart',
              left: 'center'
            },
            tooltip: {
              trigger: 'axis'
            },
            xAxis: {
              type: 'category',
              data: response.data.label
            },
            yAxis: {
              type: 'value'
            },
            series: [{
              data: data,
              type: 'bar',
              showBackground: true,
              itemStyle: { color: '#22C3AA' },
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              }
            }]
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async addSearch () {
      await this.getSaleSummary()
      await this.getSaleByMonthly()
      await this.getSaleByDaily()
      await this.getProductRank()
      // await this.getProductTopTen()
      await this.getSalesmanRank()
      await this.getNotification()
      await this.getManufactureOrder()
      // await this.getSummaryOrder()
    },
    async getSummaryOrder () {
      this.dataOrderLoading = true
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        date: end,
        company_no: this.company_no,
        type: null
      }
      await Axios.post(productUrl + '/summary-order', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataOrder = response.data.data
          var array = this.dataOrder
          for (let i = 0; i < array.length; i++) {
            if (array[i].saldo < 0) {
              var url = setRowUrl + '?begin=2022-01-01' + '&end=' + end + '&product_no=' + array[i].product_no + '&uom=' + array[i].uom_id
              console.log(url)
              Axios.get(url, { headers: getHeader() })
                .then(response => {
                  console.log(response.data.message)
                  if (parseFloat(response.data.data.total) !== parseFloat(array[i].costs.cost_qty)) {
                    array[i].saldo = parseFloat(array[i].qty_saldo) + parseFloat(array[i].purchasing_order_remaining) - parseFloat(array[i].sale_order_remaining)
                  }
                })
                .catch(error => {
                  console.log(error)
                  console.log(error.response)
                })
            }
          }
          this.dataOrderLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response.data.message)
          this.dataOrderLoading = false
        })
    },
    async getManufactureOrder () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      await Axios.post(reportUrl + '/manufacture-order-on-progress', obj, { headers: getHeader() })
        .then(response => {
          this.manufactureOrder = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
        })
    },
    getProductTopTen: function () {
      const branch = this.branch_no
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      const url = productUrl + '/top-ten?branch=' + branch + '&begin=' + begin + '&end=' + end
      console.log(url)
      Axios.get(url, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.productTopTen = response.data.data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    searchDashboard: function () {
      const branch = this.branch_no
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      const url = branch ? reportUrl + '?branch=' + branch + '&begin=' + begin + '&end=' + end : reportUrl + '?&begin=' + begin + '&end=' + end
      console.log(url)
      Axios.get(url, { headers: getHeader() })
        .then(response => {
          this.totalSales = response.data.data.totalSales
          this.loadingSales = true
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            'Cannot Get Report'
          )
        })
    }
  },
  computed: {
    ...mapState({
      branchList: state => state.branches.branchList,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser
    }),
    dataOrderMinus () {
      var array = this.dataOrder
      var loop = []
      for (let i = 0; i < array.length; i++) {
        if (array[i].saldo < 0) {
          loop.push(array[i])
        }
      }
      return loop
    },
    branchSelect: function () {
      var loop = []
      var array = this.branchList.filter(d => d.outlet_master === null)
      for (var x = 0; x < array.length; x++) {
        var obj = {
          branch: array[x].name,
          meta: {
            code: array[x].branch_no
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  mounted () {
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getCompanyList')
    this.addSearch()
  }
}
</script>

<style type="text/css">
.chart {
  height: 400px;
}
@keyframes ldio-m41ff6uvz8 {
  0% { opacity: 1 }
  50% { opacity: .5 }
  100% { opacity: 1 }
}
.ldio-m41ff6uvz8 div {
  position: absolute;
  width: 20px;
  height: 80px;
  top: 60px;
  animation: ldio-m41ff6uvz8 1s cubic-bezier(0.5,0,0.5,1) infinite;
}.ldio-m41ff6uvz8 div:nth-child(1) {
  transform: translate(30px,0);
  background: #e15b64;
  animation-delay: -0.6s;
}.ldio-m41ff6uvz8 div:nth-child(2) {
  transform: translate(70px,0);
  background: #f47e60;
  animation-delay: -0.4s;
}.ldio-m41ff6uvz8 div:nth-child(3) {
  transform: translate(110px,0);
  background: #f8b26a;
  animation-delay: -0.2s;
}.ldio-m41ff6uvz8 div:nth-child(4) {
  transform: translate(150px,0);
  background: #abbd81;
  animation-delay: -1s;
}
.loadingio-spinner-bars-km984sg9h2 {
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
  background: #ffffff;
}
.ldio-m41ff6uvz8 {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-m41ff6uvz8 div { box-sizing: content-box; }
/* generated by https://loading.io/ */
@media print {
  .noprint { display:none; }
  .printScreen { display: block; }
}
</style>
